import { Dialog } from "vant";
import logina from "../apis/login";

export const handleUnAuth = async (error) => {
  const homeUrl = localStorage.getItem("homeUrl");
  const { data: resData } = await logina.post("/api/wxapp/h5Logout");
  if (resData.code == 200) {
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = homeUrl;
  }
};
